import { useEffect } from "react";
import api from "@/lib/api";

// Injecte les balises SEO (title, meta description, Open Graph, JSON-LD Restaurant)
// depuis Réglages → SEO, sans toucher au code.
export default function SeoHead() {
  useEffect(() => {
    let cancelled = false;
    api
      .get("/settings")
      .then((r) => {
        if (cancelled) return;
        const settings = r.data || {};
        const seo = settings.seo || {};
        const contact = settings.contact || {};

        if (seo.site_title) document.title = seo.site_title;

        const setMeta = (attr, key, content) => {
          if (!content) return;
          let tag = document.head.querySelector(`meta[${attr}="${key}"]`);
          if (!tag) {
            tag = document.createElement("meta");
            tag.setAttribute(attr, key);
            document.head.appendChild(tag);
          }
          tag.setAttribute("content", content);
        };

        setMeta("name", "description", seo.site_description);
        setMeta("name", "keywords", seo.keywords);
        setMeta("property", "og:title", seo.site_title);
        setMeta("property", "og:description", seo.site_description);
        setMeta("property", "og:image", seo.og_image || settings.hero_image);
        setMeta("property", "og:type", "website");

        const jsonLd = {
          "@context": "https://schema.org",
          "@type": "Restaurant",
          name: "Palais Maasaï",
          description: seo.site_description || "Restaurant africain contemporain à Dijon",
          servesCuisine: "Africaine",
          address: {
            "@type": "PostalAddress",
            streetAddress: contact.address_street || "",
            addressLocality: "Dijon",
            addressCountry: "FR",
          },
          url: window.location.origin,
        };
        let script = document.getElementById("seo-jsonld");
        if (!script) {
          script = document.createElement("script");
          script.id = "seo-jsonld";
          script.type = "application/ld+json";
          document.head.appendChild(script);
        }
        script.textContent = JSON.stringify(jsonLd);
      })
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, []);
  return null;
}
